import Navbar from "@/pages/home/components/Navbar";
import PageBanner from "@/pages/home/components/PageBanner";
import WhyInvest from "@/pages/home/components/WhyInvest";
import Footer from "@/pages/home/components/Footer";
import CmsPage from "@/components/cms/CmsPage";

export default function WhyInvestPage() {
  return (
    <main className="w-full">
      <Navbar />
      <CmsPage slug="why-invest" path="/why-invest" fallbackSeo={{ title: "Why Invest | NOMADLIVINGS", description: "A premium A-frame villa as a diversified, income-generating hospitality asset with professional management." }}>
      <PageBanner
        eyebrow="Why Invest"
        title="A Villa Asset That"
        highlight="Works for You"
        subtitle="Discover how a premium A-frame villa becomes a diversified, income-generating hospitality asset with professional management and flexible exit options."
        image="https://readdy.ai/api/search-image?query=Interior%20of%20a%20luxury%20A-frame%20wooden%20cabin%20with%20tall%20glass%20triangular%20window%2C%20warm%20cozy%20living%20room%20with%20leather%20sofa%2C%20stone%20fireplace%20and%20soft%20morning%20light%20through%20the%20forest%2C%20elegant%20rustic%20modern%20decor%2C%20warm%20green%20and%20amber%20tones%2C%20premium%20hospitality%20photography&width=1800&height=900&seq=banner-whyinvest-x2&orientation=landscape&nocache=true"
        imageAlt="Luxury A-frame villa interior with fireplace and forest views"
        ctaLabel="Start Investing"
        ctaTo="/investments"
      />
      <WhyInvest />
      </CmsPage>
      <Footer />
    </main>
  );
}